export default __webpack_public_path__ + "static/media/cancel.6a463da2.gif";